import React, { useEffect, useRef } from "react";
import { useInput } from "react-admin";
import { TextField as MuiTextField } from "@material-ui/core";
import { Autocomplete } from '@material-ui/lab';
import config from "../config.json";
import notify from './CustomUseNotify';

export default function EsperGroupSelector(props) {
	const { input: { value: groupId, onChange: onGroupIdChange } } = useInput(props);
	const { input: { value: groupName, onChange: onGroupNameChange } } = useInput({ ...props, id: "esper_group_name", source: "esper_group_name" });

	//const notify = useNotify();

	const [value, onChange] = React.useState(null);
	const [data, setData] = React.useState([]);
	const [loading, setLoading] = React.useState(false);

	const filterTimeout = useRef(null);

	const handleGroupChange = (event, newValue) => {
		onChange(newValue);
		onGroupIdChange(newValue ? newValue.id : "");
		onGroupNameChange(newValue ? newValue.name : null);
	};

	const handleFilterInputChange = (event, inputText) => {
		if (inputText !== groupName) {
			onGroupIdChange("");
			onGroupNameChange(inputText);
		}
		if (filterTimeout.current)
			clearTimeout(filterTimeout.current);

		setLoading(true);
		filterTimeout.current = setTimeout(() => {
			fetch(`https://${config.ESPER_DOMAIN}-api.esper.cloud/api/enterprise/${config.ESPER_ENTERPRISE_ID}/devicegroup/?limit=11&name=${inputText}`, {
				method: 'GET',
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${config.ESPER_API_KEY}`,
				},
			}).then(response => response.json())
				.then(responseJson => {
					setLoading(false);
					if (responseJson.results) {
						setData(responseJson.results.filter(group => group.name !== "All devices"));
					} else {
						notify(responseJson.message, 'warning');
					}
				})
				.catch((e) => {
					setLoading(false);
					notify('Error Fetching Esper Groups', 'warning')
				});
		}, 500);
	};

	useEffect(() => {
		onChange(v => ({ ...v, id: groupId, name: groupName ? groupName : undefined }));
	}, [groupId, groupName]);

	useEffect(() => {
		if (groupId != null && groupId !== "") {
			setLoading(true);
			fetch(`https://${config.ESPER_DOMAIN}-api.esper.cloud/api/enterprise/${config.ESPER_ENTERPRISE_ID}/devicegroup/${groupId}/`, {
				method: 'GET',
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${config.ESPER_API_KEY}`,
				},
			}).then(response => response.json())
				.then(responseJson => {
					setLoading(false);
					if (responseJson.device_count != null) {
						onGroupNameChange(responseJson.name);
						onGroupIdChange(groupId);
						onChange(v => ({ ...v, name: responseJson.name }));
					} else {
						notify(responseJson.message, 'warning');
					}
				})
				.catch((e) => {
					setLoading(false);
					notify('Error Fetching Esper Group', 'warning')
				})
		}
	}, []); // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<Autocomplete
			freeSolo
			blurOnSelect
			loading={loading}
			value={value}
			onChange={handleGroupChange}
			onInputChange={handleFilterInputChange}
			options={data}
			getOptionSelected={(option, value) => option.id === value.id}
			getOptionLabel={p => p.name ? p.name : ""}
			renderInput={params => <MuiTextField {...params} label="Select Esper Group" variant="outlined" />}
			style={{ width: 300, marginTop: 10, marginBottom: 25 }}
		/>
	);
};;